import * as React from "react";
import envConfig from "../../../../utils/env-config";

export const SandboxAlert: React.FC = () => {
  const sandboxAlert = envConfig.matchEnvValue({
    dev: false,
    local: false,
    production: false,
    production_sandbox: true,
    staging: false,
    staging_sandbox: true,
  });

  if (!sandboxAlert) {
    return null;
  }

  return (
    <div
      className="has-text-weight-bold pl-3 has-text-white"
      style={{
        backgroundColor: "#fca503",
        position: "sticky",
        top: 0,
        zIndex: 1,
      }}
    >
      <nav className="level">
        <div className="level-left">
          <div className="level-item">
            <p
              style={{
                paddingTop: "12px",
                paddingBottom: "12px",
              }}
            >
              こちらの環境はサンドボックス環境です
            </p>
          </div>
        </div>
      </nav>
    </div>
  );
};
